/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatModelRef } from './chat-model-ref';


export interface AgentChat { 
    id: string;
    agentId: string;
    /**
     * Resume key — the same (agent, program, user, name) always maps to the same conversation. Distinct from `title` and never rewritten.
     */
    name: string;
    /**
     * Display label shown in the chat list. Auto-generated from the first exchange, then overridable by the user. Absent on brand-new chats.
     */
    title?: string;
    /**
     * How `title` was set: \"auto\" after the agent named the chat from its first message, \"user\" once someone renamed it. A user rename is permanent — auto-naming won\'t overwrite it.
     */
    titleSource?: AgentChat.TitleSourceEnum;
    /**
     * Model pinned at chat creation. Absent = the chat follows the program setting / platform default at turn time.
     */
    model?: ChatModelRef;
    /**
     * Sticky access mode (PUT /chats/{chatId}/mode). Absent = \"ask\". The next tool call follows it.
     */
    mode?: AgentChat.ModeEnum;
    /**
     * Sticky reasoning level (PUT /chats/{chatId}/agent). Absent = the default from GET /models. The next model request picks up the current value.
     */
    reasoning?: AgentChat.ReasoningEnum;
    createdAt: string;
    lastActivityAt: string;
    /**
     * Set on GET /agents/{agentId}/chats: an answer is running or waiting on the user. Best effort (it may lag by a moment); listing never opens a chat.
     */
    busy?: boolean;
}
export namespace AgentChat {
    export type TitleSourceEnum = 'auto' | 'user';
    export const TitleSourceEnum = {
        Auto: 'auto' as TitleSourceEnum,
        User: 'user' as TitleSourceEnum
    };
    export type ModeEnum = 'accept-all' | 'ask' | 'view';
    export const ModeEnum = {
        AcceptAll: 'accept-all' as ModeEnum,
        Ask: 'ask' as ModeEnum,
        View: 'view' as ModeEnum
    };
    export type ReasoningEnum = 'low' | 'medium' | 'high';
    export const ReasoningEnum = {
        Low: 'low' as ReasoningEnum,
        Medium: 'medium' as ReasoningEnum,
        High: 'high' as ReasoningEnum
    };
}


